import { OnInit, Component } from "@angular/core";
import { FDLMService } from '../services/FDLM.Service';
import { Router } from '@angular/router';
import { FormGroup, FormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import  Swal from 'sweetalert2';

@Component({ templateUrl: 'login.component.html'})
export class LoginComponent implements OnInit {
 
  public loginForm = this.formBuilder.group({
    usuario: ['', Validators.required],
    pwd: ['', Validators.required]
  })
  /*
  public loginForm = new FormGroup({
    usuario: new FormControl(''),
    pwd: new FormControl('')
  });
  */

  constructor(private FDLMService: FDLMService,
    private router: Router,
    private formBuilder: UntypedFormBuilder) {
    if (this.FDLMService.usuarioData)
    {
      this.router.navigate(['/']);
    }

  }

  ngOnInit() {

  };

  login() {
    this.FDLMService.login(this.loginForm.value).subscribe(response => {
      if (response.idEstado === 1) {

        if (this.FDLMService.redirectUrl) {
          this.router.navigate([this.FDLMService.redirectUrl]);
          this.FDLMService.redirectUrl = null;
        }
        else {
          this.router.navigate(['/separador']);
        }
      }
      else {
        Swal.fire({ text: response.mensaje , icon: 'warning', confirmButtonText: "Aceptar" });
        //this.snackbar.open('Usuario o contraseña no valida', '', { duration: 3000 });
      }
    })
  }

}


